import { Api as HtmlThumbnailService } from '@weave/schema-gen-ts/dist/schemas/messaging/html-thumbnail-generator/v1';
import { bindHTTP } from '@frontend/schema';

export const SchemaHtmlThumbnailService = bindHTTP(HtmlThumbnailService);
